import React from "react";
import styled from "styled-components";
import {
    ExternalTitle,
    ExternalSubtitle,
    PrimaryButton,
} from "./styled.js";
import { EXTERNAL_ACCESS_COPY } from "./constants";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 400px;
  max-width: 100%;
`;

const HeadingGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export default function AccessRestricted({ title, body, onTryAnotherEmail }) {
    return (
        <Wrapper>
            <HeadingGroup>
                <ExternalTitle>{title || EXTERNAL_ACCESS_COPY.restrictedTitle}</ExternalTitle>
                <ExternalSubtitle>{body || EXTERNAL_ACCESS_COPY.restrictedBody}</ExternalSubtitle>
            </HeadingGroup>
            <PrimaryButton onClick={onTryAnotherEmail}>
                {EXTERNAL_ACCESS_COPY.tryAnotherEmail}
            </PrimaryButton>
        </Wrapper>
    );
}
